import PropertyGridNoSidebarContainer from "../../../components/property/grid/PropertyGridNoSidebar";

const PropertyGridNoSidebar = () => {
  return <PropertyGridNoSidebarContainer />;
};

export default PropertyGridNoSidebar;
